
// 31/01


// $(document).ready(function() {
//   var selected = $(".collection-filter-ul .selected").html();
//   $('.filter-span').html(selected);
  
//  var filter = document.querySelector(".collection-filter-ul");
//  var cfilter = document.querySelector(".collection_filter");
//   if ($(".collection-filter-ul").length > 0) {
//       document.querySelector(".collection_filter .filter-span").addEventListener("click", function() {
//           filter.style.display = filter.style.display === "block" ? "none" : "block";
//           cfilter.classList.toggle('visible');
//       });
//       var listItems = document.querySelectorAll(".collection-filter-ul li");
//       listItems.forEach(function(item) {
//           item.addEventListener("click", function() {
//               var url = this.getAttribute("data-value");
//               window.location.href = url;
//           })
//       })
//   }
// });



   $(document).ready(function() {



    $(document).on("click", ".cart__checkout-button", function () { 
            console.log("here");
            var discountCode = document.getElementById("discount_code").value;
      console.log(discountCode);
            if (discountCode) {
              window.location.href = '/checkout?discount=' + discountCode;
           }else{
             window.location.href = '/checkout';
           } 
        })

// $(document).on("click", ".discount_code_remove", function () { 
//     var discountCode = document.getElementById("discount_code").value;
//     console.log(discountCode);
//     document.getElementById("promo-message-container").innerHTML = "";

//     fetch('/discount/' + discountCode)
//         .then(function() {
//             fetch('/cart/update.js', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({
//                     updates: {},
//                 }),
//             }).then(cart => {
// console.log('fsdfsdfsdfsdf')
//                 // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//                 // $('.discount_boxes').show();
//                 // $('.discount_boxes .discounr_code').text(discountCode);
//                 // if (discountCode == '') {
//                 //     document.getElementById("promo-message-container").innerHTML = "<div class='show-discount'>Please Enter Discount Code</div>";
//                 // } else {
//                 //     document.getElementById("promo-message-container").innerHTML = "<div class='show-discount'></div>";
//                 //     document.getElementById("discount_code").value = ""; // Clear the input field
//                 // }
//             }).catch(error => {
//               console.log('Error updating cart:', error);
//                 console.error('Error updating cart:', error);
//             });
//             document.getElementById("promo-message-container").innerHTML = 'Apply';
//         }).catch(function(error) {
//             console.log('Error updating cart:', error);
//         });
// });

$(".header--search a").click(function(){
if ($(window).width() < 768) {  
    
 $(".mobile-nav--search a").trigger('click');
    $(".menu-link-drawer")[0].click();
  $(".mobile-nav--search").hide();
}
});
$(".close_menu").click(function(){
    $(".mobile-nav--search").show();
})
     

setTimeout(function() {
    $('.btn-text-change .product-add-to-cart-btn').html('Add To Cart');
    }, 2000); 


     
     $('.leftside-filter').on('click', function(){
      $('.left-filter-wraper').toggleClass("active");
    })

     $('.featured-collections--root .contentWrapper').removeClass('completed_load');
      $('.featured-content--text-container').each(function() {
       var $this = $(this);
        var $btn = $this.parents('.featured-content--text').find('.read-more');
       if ($this.find('.featured-content--description').text().length > 150) {
            $btn.show();
        }

        $btn.on('click', function() {
            var $btn = $(this);
            var $content = $btn.prev('.read_more_story.featured-content--description');

            if ($btn.text() === 'Keep Reading') {
                $content.css('max-height', 'none');
                $btn.text('Hide');
              $this.find('.featured-content--description').removeClass('read_more_remove')
            } else {
                $content.css('max-height', '100px');
                $content.css('overflow', 'hidden');
                $btn.text('Keep Reading');
              $this.find('.featured-content--description').addClass('read_more_remove')
            }
        });
    });
   // document.querySelector('.home-personalized-suppliments.save_personalize .btn-orange').addEventListener('click', function(event) {
   //      event.preventDefault();
   //      var targetId = this.getAttribute('href').substring(1); 
   //      var targetElement = document.getElementById(targetId);
   //      if (targetElement) {
   //          var targetOffset = targetElement.offsetTop - 78; 
   //          window.scrollTo({
   //              top: targetOffset,
   //              behavior: 'smooth'
   //          });
   //      }
   //  });
   // document.querySelector('.n-r-2-product-subscribe-save-section.subscribe_save_exclusive .btn-orange').addEventListener('click', function(event) {
   //      event.preventDefault();
   //      var targetId = this.getAttribute('href').substring(1); 
   //      var targetElement = document.getElementById(targetId);
   //      if (targetElement) {
   //          var targetOffset = targetElement.offsetTop - 100; 
   //          window.scrollTo({
   //              top: targetOffset,
   //              behavior: 'smooth'
   //          });
   //      }
   //  });
// $(document).on('click', '#addtocart-sticky .buy-button', function() {

//   $('html, body').animate({
//       scrollTop: $(".product-page--panel-wrapper .product-buy-buttons--primary").offset().top - 400
//   }, 1500);
  
// });
      $('.article_desktop_remove.article_desktop_remove  .read_less').on('click', function() {
      var scrollPosition = 0.2 * $(window).height();
      $('html, body').animate({
        scrollTop: scrollPosition
      }, 'slow');
  var parentDiv = $(this).closest('.home-latest-articles-left');
          setTimeout(function() {
    parentDiv.addClass('blog_article_mobile');
  }, 1000);
        
    });
    // $('.article_desktop_remove.article_desktop_remove .read_more').on('click', function() {
    //  $(this).closest('.home-latest-articles-left').toggleClass('blog_article_mobile');
    // });
     $('.article_desktop_remove.article_desktop_remove .read_more').on('click', function() {
  var parentDiv = $(this).closest('.home-latest-articles-left');
    parentDiv.removeClass('blog_article_mobile');
});

$('.sticky-add-btn').click(function() {
    $('html, body').animate({
        scrollTop: $('.product-page--panel-wrapper .product-buy-buttons--primary').offset().top - 400
    }, 50);
});

     
$( "#addtocart-sticky #qty-num_sticky" ).on( "change", function() {
  $( ".product-page--panel-wrapper #qty-num").val($(this).val());
  $( ".product-page--panel-wrapper #qty-num" ).trigger( "change" );
} );
if($('.product-page--panel-wrapper .product-buy-buttons--primary').length > 0){
  $(window).on('resize scroll', function() {
      if ($('.product-page--panel-wrapper .product-buy-buttons--primary').isInViewport()) {
          $('.sticky-addtocart').addClass('hide');
      } else {
          $('.sticky-addtocart').removeClass('hide');
      }
  });
}


//     var sec         = 1800,
//     countDiv    = document.getElementById("timer"),
//     secpass,
//     countDown   = setInterval(function () {
//         'use strict';        
//         secpass();
//     }, 1000);

// function secpass() {
//     'use strict';    
//     var min     = Math.floor(sec / 60),
//         remSec  = sec % 60;    
//     if (remSec < 10) {        
//         remSec = '0' + remSec;    
//     }
//     if (min < 10) {        
//         min = '0' + min;    
//     }
//     countDiv.innerHTML = min + ":" + remSec;    
//     if (sec > 0) {        
//         sec = sec - 1;        
//     } else {        
//         clearInterval(countDown);        
//         countDiv.innerHTML = 'countdown done';        
//     }
// }

// function startTimer(duration, display) {
// var timer = duration, minutes, seconds;
// setInterval(function () {
//     minutes = parseInt(timer / 60, 10)
//     seconds = parseInt(timer % 60, 10);

//     minutes = minutes < 10 ? "0" + minutes : minutes;
//     seconds = seconds < 10 ? "0" + seconds : seconds;

//     display.textContent = minutes + ":" + seconds;

//     if (--timer < 0) {
//         timer = duration;
//     }
//   // console.log(parseInt(seconds))
//   window.localStorage.setItem("seconds",seconds)
//   window.localStorage.setItem("minutes",minutes)
// }, 1000);
// }

//   window.onload = function () {
//     sec  = parseInt(window.localStorage.getItem("seconds"))
//     min = parseInt(window.localStorage.getItem("minutes"))
   
//     if(parseInt(min*sec)){
//       var fiveMinutes = (parseInt(min*60)+sec);
//     }else{
//       var fiveMinutes = 60 * 30;
//     }
//       // var fiveMinutes = 60 * 5;
//     display = document.querySelector('#timer');
//       startTimer(fiveMinutes, display);
//       // $('.featured-collections--root .contentWrapper').removeClass('completed_load');
//   };

     function updateCountdown() {
                var now = new Date().getTime();
                var endTime = localStorage.getItem('endTime');
                if (!endTime) {
                    endTime = new Date().getTime() + (30 * 60 * 1000);
                    localStorage.setItem('endTime', endTime);
                }
                var distance = endTime - now;
                if (distance < 0) {
                    clearInterval(interval);
                    $('#countdown').text("EXPIRED");
                    localStorage.removeItem('endTime'); // Clear the stored end time
                    return;
                }
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);
                $('#countdown').text(minutes + ":" + seconds);
            }

            // Update the countdown every second
            var interval = setInterval(updateCountdown, 1000);

     
    if ($(window).width() > 576) {
        $('.featured-collection--slider--slick').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        arrows: true,
                    },
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true,
                    },
                },
            ],
        });
    }
     
setTimeout(function() {
    $('.product-page--root .opinew-stars-plugin-link').attr('href', 'javascript:void(0);');
    }, 1000);

     
      $('.product-page--root .opinew-stars-plugin-link').click(function() {
    if($(".n-r-2-app-wrapper-section").length > 0){
      $('html, body').animate({
            scrollTop: $(".n-r-2-app-wrapper-section").offset().top - 200
        }, 100);
    }
  });
     
      $(document).on('change','#qty-num', function() {
        $(this).parents('.product-page--featured-blocks').find('.form-hidden-qty-num').val(this.value);
         $( "#addtocart-sticky #qty-num_sticky").val($(this).val());
      });
     
     if ($(window).width() < 769 ) {
      $('.save_bundle .bundle_slider').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: false,
        responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                         arrows: true,
                        dots:true,
                       infinite: false,
                    },
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                         arrows: true,
                        dots:true,
                       infinite: false,
                    },
                  }
          ]
      });   


    setTimeout(function() {
    $("#bundle_save .n-r-2-plants-ingredients-1").each(function() {
    var bprice = $(this).find('.rc_price__autodeliver').html();
    $(this).find('.product_cprice').html(bprice);
    });
    }, 3800);


  $('.product-ingredients-section .n-r-2-plants-ingredients-1').addClass('active');
  $('.product-ingredients-section .n-r-2-plants-ingredients-data-t').click(function() {
    $(this).closest('.product-ingredients-section .n-r-2-plants-ingredients-1').toggleClass('active');
  });

 $('.feature_more .featured-blog--grid').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: false,
        responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                         arrows: true,
                        dots:true,
                       infinite: false,
                    },
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                         arrows: true,
                        dots:true,
                       infinite: false,
                    },
                  }
          ]
      }); 

   } 
     
      var minusButton = $('.cart--minus');
      var inputElement = $('.cart--quantity--input');
      inputElement.on('input', function() {
        var inputValue = parseInt($(this).val(), 10);
        if (inputValue <= 1) {
          minusButton.addClass('cart--minus-disabled');
        } else {
          minusButton.removeClass('cart--minus-disabled');
        }
      });

     $('.nutririse-sorting').on('click', function(){
       $(this).toggleClass('active');
     })
     
     $('.nutririse-sorting li').on('click', function(){
       var value = $(this).data('val');
       // $('.nutririse-sorting .filter-span').html(value);
       var url = window.location.href;
        var url1 = new window.URL(document.location);
         if(url.indexOf('sort_by') !== -1){
         url1.searchParams.set('sort_by', value);
           window.location.href = url1;
         }else{
           window.location.href = url+'?sort_by='+value;
         }
       
     });
     // 27/12     

    if (!$(".cart--bundle .all_product .cart--bestsellers-products").hasClass("slick-initialized")) {
      $('.cart--bundle .all_product .cart--bestsellers-products').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
              infinite: true
        });
    }
  setTimeout(function() {
      $('.cart--bundle .all_product .cart--bestsellers-products').slick('setPosition'); 
   }, 1000);

     setTimeout(function() {
      $('.cart--bundle .all_product .cart--bestsellers-products').slick('setPosition'); 
      $('.product-page--featured-media').css('opacity', '1');
   }, 300);
     

     $(".off-canvas--right-sidebar").bind("DOMSubtreeModified", function() {
     
          if (!$(".cart--bundle .all_product .cart--bestsellers-products").hasClass("slick-initialized")) {
              $('.cart--bundle .all_product .cart--bestsellers-products').slick({
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows: false,
                      dots: false,
                      infinite: true
                });
            }
        
    });
     
    $('#main-header .header--right-side .cart-link [data-off-canvas--view="cart"]  , .product-buy-buttons--root .product-detail-add-to-cart').click(function(){
      setTimeout(function(){
      $('body').addClass('open_cart'); 
        $('.cart--bundle .all_product .cart--bestsellers-products').slick('setPosition');
        },200);
    });
        $('.cart--item--remove').on('click', function(){
         $('.cart--bundle .all_product .cart--bestsellers-products').slick('setPosition');
           
        });
    $('.off-canvas--viewport [aria-label="close"]').click(function(){
       $('body').removeClass('open_cart'); 
    });
     
     $(document).on('click', function (e) {
      if ($(e.target).closest(".off-canvas--right-sidebar").length == 0) {
       $('body').removeClass('open_cart'); 
      }
    });
 setTimeout(function() {
     $("#bundle_save .n-r-2-plants-ingredients-1").each(function() {
       var bprice = $(this).find('.rc_price__autodeliver').html();
       $(this).find('.product_cprice').html(bprice);
       if($("#bundle_save .rc_block__type--active .rc_radio").hasClass('rc_radio__onetime')){
          $("#bundle_save").find('.product_cprice').hide(); 
          $("#bundle_save").find('#product_price').addClass('removestrike');
        }
     });
   }, 2500);

$('#bundle_save .rc_radio').on('click', function(){ 
  if($(this).hasClass('rc_radio__autodeliver')){
    $(this).parents('.product-buy-buttons--root').find('.product_cprice').show(); 
    $(this).parents('.product-buy-buttons--root').find('#product_price').removeClass('removestrike');
  }
  if($(this).hasClass('rc_radio__onetime')){
    $(this).parents('.product-buy-buttons--root').find('.product_cprice').hide(); 
    $(this).parents('.product-buy-buttons--root').find('#product_price').addClass('removestrike');
  }
});

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

           $('.toggle-products').on('click', function (e) {
   e.preventDefault()
   
     $('.toggle-products').text("+");
            $('.toggle-products').not($(this)).removeClass('active');
            $('.filter--link .all_products').not($(this).closest('.filter--link').find('.all_products')).hide();
            $(this).toggleClass('active');
            $(this).closest('.filter--link').find('.all_products').toggle();
            if ($(this).hasClass('active')) {
              
                $(this).text('-');
            } else {
                $(this).text('+');
            }
     
        });



   $(document).on("click", "p.read-more-less", function () {
    if ($(this).text() == "Read Less") {
      $(this).parent().find(".small-content").show();
      $(this).parent().find(".large-content").hide();
      $(this).text("Keep Reading");
    } else {
      $(this).parent().find(".small-content").hide();
      $(this).parent().find(".large-content").show();
      $(this).text("Read Less");
    }
  });

     
});

